import { axios, base } from '../http';

/** 获取学校方案档案 */
export const getSchoolSchemeProfile = (params) =>
  axios.get(`${base}/api/SchemeSwitch/GetSchoolSchemeProfile`, { params });

/** 保存方案名称 */
export const saveSchoolSchemeProfile = (params) =>
  axios.post(`${base}/api/SchemeSwitch/SaveSchoolSchemeProfile`, params);

/** 创建/更新备用（覆盖写入 BackupPayload） */
export const createOrUpdateBackup = (params) =>
  axios.post(`${base}/api/SchemeSwitch/CreateOrUpdateBackup`, params);

/** 按校切换主备 */
export const batchSwitch = (params) =>
  axios.post(`${base}/api/SchemeSwitch/BatchSwitch`, params);

/** 门禁启停 */
export const setAccessEnabled = (params) =>
  axios.post(`${base}/api/SchemeSwitch/SetAccessEnabled`, params);

/** 门禁重同步天波 */
export const resyncAccess = (params) =>
  axios.post(`${base}/api/SchemeSwitch/ResyncAccess`, params);

/** 切换日志 */
export const getSchemeSwitchLogs = (params) =>
  axios.get(`${base}/api/SchemeSwitch/GetLogs`, { params });
